// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27rgba%28255, 255, 255, 0.4%29%27 stroke-width=%271%27%3E%3Cpath d=%27M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z%27 /%3E%3Cpath d=%27M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z%27 /%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27rgba%28255, 255, 255, 0.2%29%27 stroke-width=%271%27%3E%3Cpath d=%27M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z%27 /%3E%3Cpath d=%27M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z%27 /%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Animations for the Robot-Based Framework for Automation Testing */

/* Simple Animated Background */
.simple-animated-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
}

.simple-animated-element {
  position: absolute;
  animation: simpleFloat linear infinite;
  pointer-events: none;
}

.simple-animated-element.circle {
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.3);
}

.simple-animated-element.square {
  background-color: rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.3);
}

.simple-animated-element.triangle {
  width: 0 !important;
  height: 0 !important;
  background-color: transparent !important;
  border-left: 25px solid transparent;
  border-right: 25px solid transparent;
  border-bottom: 50px solid rgba(255, 255, 255, 0.5);
  filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.3));
}

.simple-animated-code {
  position: absolute;
  font-family: monospace;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  animation: simpleFloat linear infinite;
  pointer-events: none;
  white-space: nowrap;
}

.simple-animated-gear {
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  animation: simpleRotate linear infinite;
  pointer-events: none;
}

@keyframes simpleFloat {
  0% {
    transform: translate(0, 0) rotate(0deg);
  }
  25% {
    transform: translate(50px, 20px) rotate(90deg);
  }
  50% {
    transform: translate(0, 50px) rotate(180deg);
  }
  75% {
    transform: translate(-50px, 20px) rotate(270deg);
  }
  100% {
    transform: translate(0, 0) rotate(360deg);
  }
}

@keyframes simpleRotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Floating Objects */
.floating-objects-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
}

.floating-object {
  position: absolute;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.15);
  animation: float 20s ease-in-out infinite alternate;
  pointer-events: none;
}

.floating-object.large {
  opacity: 0.2;
}

.floating-object.medium {
  opacity: 0.15;
}

.floating-object.small {
  opacity: 0.1;
}

.floating-object.circle {
  border-radius: 50%;
}

.floating-object.square {
  border-radius: 0;
}

.floating-object.triangle {
  width: 0 !important;
  height: 0 !important;
  background-color: transparent !important;
  border-left: 50px solid transparent;
  border-right: 50px solid transparent;
  border-bottom: 86px solid rgba(255, 255, 255, 0.15);
}

.floating-object.hexagon {
  clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
}

.floating-code {
  position: absolute;
  font-family: monospace;
  color: rgba(255, 255, 255, 0.2);
  font-size: 14px;
  animation: floatCode 25s linear infinite;
  pointer-events: none;
  white-space: nowrap;
}

.floating-gear {
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: center;
  animation: rotateGear 30s linear infinite;
  pointer-events: none;
  opacity: 0.2;
}

@keyframes float {
  0% {
    transform: translateY(0) translateX(0) rotate(0);
  }
  25% {
    transform: translateY(-50px) translateX(20px) rotate(90deg);
  }
  50% {
    transform: translateY(20px) translateX(-30px) rotate(180deg);
  }
  75% {
    transform: translateY(30px) translateX(40px) rotate(270deg);
  }
  100% {
    transform: translateY(-20px) translateX(-20px) rotate(360deg);
  }
}

@keyframes floatCode {
  0% {
    transform: translateX(-100%) translateY(0);
  }
  100% {
    transform: translateX(100vw) translateY(20px);
  }
}

@keyframes rotateGear {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Animated Background Canvas */
.animated-background-canvas {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  opacity: 1;
}

/* Floating animation for the robot */
@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0px);
  }
}

/* Pulse animation for the robot eyes */
@keyframes pulse {
  0% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.7;
  }
}

/* Rotate animation for gears */
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Slow rotate animation for background elements */
@keyframes slowRotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Typing cursor animation */
@keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

/* Fade in animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Slide in from left animation */
@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Slide in from right animation */
@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Background gradient animation */
@keyframes gradientFlow {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

/* Code typing animation */
@keyframes typing {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

/* Robot animation container */
.robot-animation {
  position: relative;
  width: 300px;
  height: 300px;
  margin: 0 auto;
  animation: float 6s ease-in-out infinite;
}

/* Animated background elements */
.animated-bg-element {
  position: absolute;
  opacity: 0.1;
  z-index: 0;
}

.animated-bg-element.gear {
  animation: rotate 20s linear infinite;
}

.animated-bg-element.circle {
  animation: pulse 8s ease-in-out infinite;
}

.animated-bg-element.square {
  animation: slowRotate 30s linear infinite;
}

/* Code lines animation */
.code-line {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  border-right: 3px solid;
  width: 0;
  animation: typing 3.5s steps(40, end) forwards, blink 1s step-end infinite;
}

.code-line:nth-child(1) {
  animation-delay: 0s;
}

.code-line:nth-child(2) {
  animation-delay: 1s;
}

.code-line:nth-child(3) {
  animation-delay: 2s;
}

.code-line:nth-child(4) {
  animation-delay: 3s;
}

/* Animated robot parts */
.robot-head {
  animation: float 4s ease-in-out infinite;
}

.robot-eye {
  animation: pulse 2s ease-in-out infinite;
}

.robot-arm {
  transform-origin: top center;
  animation: rotate 10s linear infinite;
}

/* Form animations */
.animated-form-group {
  animation: fadeIn 0.5s ease-out forwards;
  opacity: 0;
}

.animated-form-group:nth-child(1) {
  animation-delay: 0.1s;
}

.animated-form-group:nth-child(2) {
  animation-delay: 0.2s;
}

.animated-form-group:nth-child(3) {
  animation-delay: 0.3s;
}

.animated-form-group:nth-child(4) {
  animation-delay: 0.4s;
}

/* Button animations */
.btn-animated {
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.btn-animated:before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  transition: all 0.6s;
}

.btn-animated:hover:before {
  left: 100%;
}

.btn-loading-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.btn-loading-content svg {
  flex-shrink: 0;
  animation: spin 1s linear infinite;
}

/* Animated background for the left section */
.animated-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;
}

.animated-background:before {
  content: '';
  position: absolute;
  top: -10%;
  left: -10%;
  width: 120%;
  height: 120%;
  background: linear-gradient(
    -45deg,
    rgba(67, 97, 238, 0.8),
    rgba(76, 201, 240, 0.8),
    rgba(67, 97, 238, 0.8),
    rgba(76, 201, 240, 0.8)
  );
  background-size: 400% 400%;
  animation: gradientFlow 15s ease infinite;
  z-index: -1;
}

/* Animated particles */
.particles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;
}

.particle {
  position: absolute;
  display: block;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  animation: float 6s infinite;
}

/* Robot code animation */
.robot-code-container {
  font-family: monospace;
  color: rgba(255, 255, 255, 0.7);
  text-align: left;
  margin: 20px auto;
  max-width: 400px;
  padding: 15px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  position: relative;
  overflow: hidden;
}

/* Animated robot illustration */
.robot-illustration {
  position: relative;
  width: 200px;
  height: 200px;
  margin: 0 auto;
}

.robot-illustration svg {
  width: 100%;
  height: 100%;
}

.robot-illustration .robot-antenna {
  transform-origin: bottom center;
  animation: float 2s ease-in-out infinite;
}

.robot-illustration .robot-head {
  animation: float 4s ease-in-out infinite;
}

.robot-illustration .robot-eye {
  animation: pulse 2s ease-in-out infinite;
}

.robot-illustration .robot-arm-left {
  transform-origin: top right;
  animation: float 3s ease-in-out infinite;
}

.robot-illustration .robot-arm-right {
  transform-origin: top left;
  animation: float 3s ease-in-out infinite reverse;
}

/* Animated form inputs */
.form-input-animated {
  transition: all 0.3s ease;
  border: 1px solid transparent;
  background-image: linear-gradient(white, white), 
                    linear-gradient(90deg, #4361ee, #4cc9f0);
  background-origin: border-box;
  background-clip: padding-box, border-box;
  background-size: 200% auto;
}

.form-input-animated:focus {
  background-position: right center;
  box-shadow: 0 0 15px rgba(76, 201, 240, 0.2);
}

/* Social button animations */
.social-btn-animated {
  transition: all 0.3s ease;
  transform: translateY(0);
}

.social-btn-animated:hover {
  transform: translateY(-5px);
}

/* Success animation */
@keyframes checkmark {
  0% {
    stroke-dashoffset: 100;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

.success-checkmark {
  stroke-dasharray: 100;
  stroke-dashoffset: 100;
  animation: checkmark 1s ease-in-out forwards;
}

/* Error shake animation */
@keyframes shake {
  0%, 100% {transform: translateX(0);}
  10%, 30%, 50%, 70%, 90% {transform: translateX(-5px);}
  20%, 40%, 60%, 80% {transform: translateX(5px);}
}

.error-shake {
  animation: shake 0.6s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/styles/animations.css"],"names":[],"mappings":"AAAA,oEAAoE;;AAEpE,+BAA+B;AAC/B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;EACxC,mCAAmC;EACnC,oCAAoC;EACpC,kDAAkD;EAClD,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yDAA83H;EAC93H,4BAA4B;EAC5B,2BAA2B;EAC3B,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE;IACE,uCAAuC;EACzC;EACA;IACE,8CAA8C;EAChD;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,gDAAgD;EAClD;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,mDAAmD;EACnD,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;EACxC,mCAAmC;EACnC,oCAAoC;EACpC,mDAAmD;AACrD;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;EAC/B,eAAe;EACf,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yDAA83H;EAC93H,4BAA4B;EAC5B,2BAA2B;EAC3B,yCAAyC;EACzC,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,2DAA2D;EAC7D;EACA;IACE,4DAA4D;EAC9D;EACA;IACE,2DAA2D;EAC7D;EACA;IACE,6DAA6D;EAC/D;AACF;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,UAAU;AACZ;;AAEA,qCAAqC;AACrC;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,kDAAkD;AAClD;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,QAAQ;EACV;EACA;IACE,WAAW;EACb;AACF;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,wCAAwC;AAC1C;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0EAA0E;AAC5E;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA,oBAAoB;AACpB;EACE,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ;;;;;;GAMC;EACD,0BAA0B;EAC1B,yCAAyC;EACzC,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,yBAAyB;AACzB;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,6BAA6B;EAC7B;4DAC0D;EAC1D,6BAA6B;EAC7B,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA,0BAA0B;AAC1B;EACE,UAAU,wBAAwB,CAAC;EACnC,yBAAyB,2BAA2B,CAAC;EACrD,oBAAoB,0BAA0B,CAAC;AACjD;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":["/* Animations for the Robot-Based Framework for Automation Testing */\n\n/* Simple Animated Background */\n.simple-animated-background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.simple-animated-element {\n  position: absolute;\n  animation: simpleFloat linear infinite;\n  pointer-events: none;\n}\n\n.simple-animated-element.circle {\n  border-radius: 50%;\n  background-color: rgba(255, 255, 255, 0.5);\n  box-shadow: 0 0 15px rgba(255, 255, 255, 0.3);\n}\n\n.simple-animated-element.square {\n  background-color: rgba(255, 255, 255, 0.5);\n  box-shadow: 0 0 15px rgba(255, 255, 255, 0.3);\n}\n\n.simple-animated-element.triangle {\n  width: 0 !important;\n  height: 0 !important;\n  background-color: transparent !important;\n  border-left: 25px solid transparent;\n  border-right: 25px solid transparent;\n  border-bottom: 50px solid rgba(255, 255, 255, 0.5);\n  filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.3));\n}\n\n.simple-animated-code {\n  position: absolute;\n  font-family: monospace;\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 14px;\n  animation: simpleFloat linear infinite;\n  pointer-events: none;\n  white-space: nowrap;\n}\n\n.simple-animated-gear {\n  position: absolute;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='rgba(255, 255, 255, 0.4)' stroke-width='1'%3E%3Cpath d='M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z' /%3E%3Cpath d='M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z' /%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  animation: simpleRotate linear infinite;\n  pointer-events: none;\n}\n\n@keyframes simpleFloat {\n  0% {\n    transform: translate(0, 0) rotate(0deg);\n  }\n  25% {\n    transform: translate(50px, 20px) rotate(90deg);\n  }\n  50% {\n    transform: translate(0, 50px) rotate(180deg);\n  }\n  75% {\n    transform: translate(-50px, 20px) rotate(270deg);\n  }\n  100% {\n    transform: translate(0, 0) rotate(360deg);\n  }\n}\n\n@keyframes simpleRotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Floating Objects */\n.floating-objects-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.floating-object {\n  position: absolute;\n  border-radius: 50%;\n  background-color: rgba(255, 255, 255, 0.15);\n  animation: float 20s ease-in-out infinite alternate;\n  pointer-events: none;\n}\n\n.floating-object.large {\n  opacity: 0.2;\n}\n\n.floating-object.medium {\n  opacity: 0.15;\n}\n\n.floating-object.small {\n  opacity: 0.1;\n}\n\n.floating-object.circle {\n  border-radius: 50%;\n}\n\n.floating-object.square {\n  border-radius: 0;\n}\n\n.floating-object.triangle {\n  width: 0 !important;\n  height: 0 !important;\n  background-color: transparent !important;\n  border-left: 50px solid transparent;\n  border-right: 50px solid transparent;\n  border-bottom: 86px solid rgba(255, 255, 255, 0.15);\n}\n\n.floating-object.hexagon {\n  clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);\n}\n\n.floating-code {\n  position: absolute;\n  font-family: monospace;\n  color: rgba(255, 255, 255, 0.2);\n  font-size: 14px;\n  animation: floatCode 25s linear infinite;\n  pointer-events: none;\n  white-space: nowrap;\n}\n\n.floating-gear {\n  position: absolute;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='rgba(255, 255, 255, 0.2)' stroke-width='1'%3E%3Cpath d='M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z' /%3E%3Cpath d='M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z' /%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  animation: rotateGear 30s linear infinite;\n  pointer-events: none;\n  opacity: 0.2;\n}\n\n@keyframes float {\n  0% {\n    transform: translateY(0) translateX(0) rotate(0);\n  }\n  25% {\n    transform: translateY(-50px) translateX(20px) rotate(90deg);\n  }\n  50% {\n    transform: translateY(20px) translateX(-30px) rotate(180deg);\n  }\n  75% {\n    transform: translateY(30px) translateX(40px) rotate(270deg);\n  }\n  100% {\n    transform: translateY(-20px) translateX(-20px) rotate(360deg);\n  }\n}\n\n@keyframes floatCode {\n  0% {\n    transform: translateX(-100%) translateY(0);\n  }\n  100% {\n    transform: translateX(100vw) translateY(20px);\n  }\n}\n\n@keyframes rotateGear {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Animated Background Canvas */\n.animated-background-canvas {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  pointer-events: none;\n  opacity: 1;\n}\n\n/* Floating animation for the robot */\n@keyframes float {\n  0% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(-20px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n\n/* Pulse animation for the robot eyes */\n@keyframes pulse {\n  0% {\n    opacity: 0.7;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.7;\n  }\n}\n\n/* Rotate animation for gears */\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Slow rotate animation for background elements */\n@keyframes slowRotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Typing cursor animation */\n@keyframes blink {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n}\n\n/* Fade in animation */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Slide in from left animation */\n@keyframes slideInLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-50px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Slide in from right animation */\n@keyframes slideInRight {\n  from {\n    opacity: 0;\n    transform: translateX(50px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Background gradient animation */\n@keyframes gradientFlow {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n/* Code typing animation */\n@keyframes typing {\n  from {\n    width: 0;\n  }\n  to {\n    width: 100%;\n  }\n}\n\n/* Robot animation container */\n.robot-animation {\n  position: relative;\n  width: 300px;\n  height: 300px;\n  margin: 0 auto;\n  animation: float 6s ease-in-out infinite;\n}\n\n/* Animated background elements */\n.animated-bg-element {\n  position: absolute;\n  opacity: 0.1;\n  z-index: 0;\n}\n\n.animated-bg-element.gear {\n  animation: rotate 20s linear infinite;\n}\n\n.animated-bg-element.circle {\n  animation: pulse 8s ease-in-out infinite;\n}\n\n.animated-bg-element.square {\n  animation: slowRotate 30s linear infinite;\n}\n\n/* Code lines animation */\n.code-line {\n  display: block;\n  overflow: hidden;\n  white-space: nowrap;\n  border-right: 3px solid;\n  width: 0;\n  animation: typing 3.5s steps(40, end) forwards, blink 1s step-end infinite;\n}\n\n.code-line:nth-child(1) {\n  animation-delay: 0s;\n}\n\n.code-line:nth-child(2) {\n  animation-delay: 1s;\n}\n\n.code-line:nth-child(3) {\n  animation-delay: 2s;\n}\n\n.code-line:nth-child(4) {\n  animation-delay: 3s;\n}\n\n/* Animated robot parts */\n.robot-head {\n  animation: float 4s ease-in-out infinite;\n}\n\n.robot-eye {\n  animation: pulse 2s ease-in-out infinite;\n}\n\n.robot-arm {\n  transform-origin: top center;\n  animation: rotate 10s linear infinite;\n}\n\n/* Form animations */\n.animated-form-group {\n  animation: fadeIn 0.5s ease-out forwards;\n  opacity: 0;\n}\n\n.animated-form-group:nth-child(1) {\n  animation-delay: 0.1s;\n}\n\n.animated-form-group:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.animated-form-group:nth-child(3) {\n  animation-delay: 0.3s;\n}\n\n.animated-form-group:nth-child(4) {\n  animation-delay: 0.4s;\n}\n\n/* Button animations */\n.btn-animated {\n  position: relative;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.btn-animated:before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 0.2) 50%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  transition: all 0.6s;\n}\n\n.btn-animated:hover:before {\n  left: 100%;\n}\n\n.btn-loading-content {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.btn-loading-content svg {\n  flex-shrink: 0;\n  animation: spin 1s linear infinite;\n}\n\n/* Animated background for the left section */\n.animated-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  z-index: 0;\n}\n\n.animated-background:before {\n  content: '';\n  position: absolute;\n  top: -10%;\n  left: -10%;\n  width: 120%;\n  height: 120%;\n  background: linear-gradient(\n    -45deg,\n    rgba(67, 97, 238, 0.8),\n    rgba(76, 201, 240, 0.8),\n    rgba(67, 97, 238, 0.8),\n    rgba(76, 201, 240, 0.8)\n  );\n  background-size: 400% 400%;\n  animation: gradientFlow 15s ease infinite;\n  z-index: -1;\n}\n\n/* Animated particles */\n.particles {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  z-index: 0;\n}\n\n.particle {\n  position: absolute;\n  display: block;\n  background-color: rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  animation: float 6s infinite;\n}\n\n/* Robot code animation */\n.robot-code-container {\n  font-family: monospace;\n  color: rgba(255, 255, 255, 0.7);\n  text-align: left;\n  margin: 20px auto;\n  max-width: 400px;\n  padding: 15px;\n  background-color: rgba(0, 0, 0, 0.1);\n  border-radius: 5px;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Animated robot illustration */\n.robot-illustration {\n  position: relative;\n  width: 200px;\n  height: 200px;\n  margin: 0 auto;\n}\n\n.robot-illustration svg {\n  width: 100%;\n  height: 100%;\n}\n\n.robot-illustration .robot-antenna {\n  transform-origin: bottom center;\n  animation: float 2s ease-in-out infinite;\n}\n\n.robot-illustration .robot-head {\n  animation: float 4s ease-in-out infinite;\n}\n\n.robot-illustration .robot-eye {\n  animation: pulse 2s ease-in-out infinite;\n}\n\n.robot-illustration .robot-arm-left {\n  transform-origin: top right;\n  animation: float 3s ease-in-out infinite;\n}\n\n.robot-illustration .robot-arm-right {\n  transform-origin: top left;\n  animation: float 3s ease-in-out infinite reverse;\n}\n\n/* Animated form inputs */\n.form-input-animated {\n  transition: all 0.3s ease;\n  border: 1px solid transparent;\n  background-image: linear-gradient(white, white), \n                    linear-gradient(90deg, #4361ee, #4cc9f0);\n  background-origin: border-box;\n  background-clip: padding-box, border-box;\n  background-size: 200% auto;\n}\n\n.form-input-animated:focus {\n  background-position: right center;\n  box-shadow: 0 0 15px rgba(76, 201, 240, 0.2);\n}\n\n/* Social button animations */\n.social-btn-animated {\n  transition: all 0.3s ease;\n  transform: translateY(0);\n}\n\n.social-btn-animated:hover {\n  transform: translateY(-5px);\n}\n\n/* Success animation */\n@keyframes checkmark {\n  0% {\n    stroke-dashoffset: 100;\n  }\n  100% {\n    stroke-dashoffset: 0;\n  }\n}\n\n.success-checkmark {\n  stroke-dasharray: 100;\n  stroke-dashoffset: 100;\n  animation: checkmark 1s ease-in-out forwards;\n}\n\n/* Error shake animation */\n@keyframes shake {\n  0%, 100% {transform: translateX(0);}\n  10%, 30%, 50%, 70%, 90% {transform: translateX(-5px);}\n  20%, 40%, 60%, 80% {transform: translateX(5px);}\n}\n\n.error-shake {\n  animation: shake 0.6s ease-in-out;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
